var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTipBox = function SvgTipBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.333 15.76h2.84a1.704 1.704 0 1 0 0-3.408H9.66",
    stroke: "#6B7280",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.943H9.66a1.705 1.705 0 1 0 0 3.41M10.417 8.187v8.333",
    stroke: "#6B7280",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.07 5.686c.483 1.17 1.014 2.767 1.014 4.14 0 1.616-.56 4.755-.964 6.809a2.45 2.45 0 0 1-2.417 1.967H7.101a2.433 2.433 0 0 1-2.4-1.934c-.403-1.967-.95-4.982-.95-6.842 0-1.533.602-3.044 1.178-4.14",
    stroke: "#6B7280",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.245 3.376a.417.417 0 0 1 .35-.19h9.645a.417.417 0 0 1 .35.19l1.078 1.666a.417.417 0 0 1-.35.644H4.517a.417.417 0 0 1-.35-.644l1.078-1.666v0Z",
    stroke: "#6B7280",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTipBox;